export default ({ app }, inject) => {
  inject('isInLP', () => {
    return !!app.context.route.query['live-preview']
  })
}
